<div class="w-100 p-4" [ngStyle]="{ 'background-color': bgColor }">
  <!--Header-->
  <div>
    @if (title) {
      <div class="text-center uw-timeline-header">{{title | translate}}</div>
    }
    <ng-content slot="timelineHeaderContent"></ng-content>
  </div>

  <!--Time line Display-->
  @if (timelineMetadata && timelineMetadata.events && timelineMetadata.events.length > 0) {
    <div>
      <div class="align-items-center d-flex h-100">
        <div class="uw-timeline-container scroll-div pb-4 mb-5">
          @for (event of timelineMetadata.events; track $index; let i = $index) {
            <div class="timeline-event">
              <!-- Event status indicator -->
              <!--Make sure that ngSwitch value and ngSwitchCase value are of same type as
              === is being used as equality operator starting angular 17-->
              @switch (event.eventStatus) {
                @case ('completed') {
                  <uw-status-indicator status="success"></uw-status-indicator>
                }
                @case ('failed') {
                  <uw-status-indicator status="error"></uw-status-indicator>
                }
                @case ('inprocess') {
                  <uw-status-indicator status="processing"></uw-status-indicator>
                }
                @case ('cancelled') {
                  <uw-status-indicator status="cancelled"></uw-status-indicator>
                }
                @default {
                  <div class="circle">
                    <div class="inner-circle inner-circle-filled"></div>
                  </div>
                }
              }
              <div style="position: relative;">
                <!-- Line between events -->
                @if (i < timelineMetadata.events.length - 1) {
                  <div class="line"></div>
                }
                <!-- Event detail card -->
                @if (i < timelineMetadata.events.length) {
                  <mat-card
                    [ngStyle]="{'background-color': event.eventCardBgColor}"
                    [ngClass]="{'event-detail-lower' :i%2!=0, 'event-detail-upper': i%2==0}" class="event-details">
                    <mat-card-header>
                      <mat-card-title>{{event.eventTitle}}</mat-card-title>
                      <mat-card-subtitle>{{event.eventSubtitle}}</mat-card-subtitle>
                    </mat-card-header>
                    <mat-card-content>
                      <p>{{event.eventContent}}</p>
                    </mat-card-content>
                  </mat-card>
                }
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  }

  <!--No Data Container-->
  @if ((!timelineMetadata?.events || (timelineMetadata?.events && timelineMetadata?.events?.length==0)) && !!timelineMetadata?.isLoaded) {
    <app-no-record-container
      message="{{ noDataMessage | translate }}">
    </app-no-record-container>
  }
</div>